import {
  MainPageType,
  useLastVisitedMainPage,
  useSearchParamChangeObserver,
  useSessionQueryString,
  WbHeader,
} from '@agilelab/plugin-wb-platform';
import { Content } from '@backstage/core-components';
import { useRouteRef } from '@backstage/core-plugin-api';
import { makeStyles } from '@material-ui/core';
import { marketplaceSearchRef } from '../../routes';
import { SearchPageContent } from './components/SearchPageContent';
import { WbPage } from '@agilelab/plugin-wb-platform';

const useStyles = makeStyles(
  () => ({
    content: {
      minHeight: 0,
    },
  }),
  { name: 'SearchPage' },
);

export const SearchPage = () => {
  const classes = useStyles();
  const [_, setLastVisitedMainPage] = useLastVisitedMainPage(
    MainPageType.MARKETPLACE,
  );

  const searchResultsRoute = useRouteRef(marketplaceSearchRef);
  setLastVisitedMainPage(searchResultsRoute());

  const [_sessionQueryString, setSessionQueryString] = useSessionQueryString();
  useSearchParamChangeObserver(
    (_previousSearch: string, currentSearch: string) => {
      setSessionQueryString(currentSearch);
    },
  );

  return (
    <WbPage themeId="home">
      <Content className={classes.content}>
        <WbHeader title="Search" hidden />
        <SearchPageContent />
      </Content>
    </WbPage>
  );
};
